const CONSENT_KEY = "ultimateFantasyAnalyticsConsent";
const CONSENT_EVENT = "ultimate-fantasy-analytics-consent";
let analyticsUserId = null;

const getMeasurementId = () => process.env.REACT_APP_GA_MEASUREMENT_ID;

export const getAnalyticsConsent = () => localStorage.getItem(CONSENT_KEY);

export const setAnalyticsConsent = (consent) => {
  localStorage.setItem(CONSENT_KEY, consent);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: consent }));
};

export const onAnalyticsConsentChange = (handler) => {
  window.addEventListener(CONSENT_EVENT, handler);
  return () => window.removeEventListener(CONSENT_EVENT, handler);
};

export const initializeAnalytics = (userId = analyticsUserId) => {
  analyticsUserId = userId || null;

  const measurementId = getMeasurementId();
  if (!measurementId || getAnalyticsConsent() !== "granted") {
    return false;
  }

  window[`ga-disable-${measurementId}`] = false;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  if (!document.getElementById("google-analytics-script")) {
    const script = document.createElement("script");
    script.id = "google-analytics-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.gtag("js", new Date());
  }

  window.gtag("consent", "update", { analytics_storage: "granted" });
  window.gtag("config", measurementId, {
    send_page_view: false,
    user_id: analyticsUserId || undefined,
    anonymize_ip: true,
  });
  return true;
};

export const disableAnalytics = () => {
  const measurementId = getMeasurementId();
  if (window.gtag) {
    window.gtag("consent", "update", { analytics_storage: "denied" });
  }
  if (measurementId) {
    window[`ga-disable-${measurementId}`] = true;
  }

  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    if (name === "_gid" || name.startsWith("_ga")) {
      document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    }
  });
};

export const trackPageView = (path, userId) => {
  if (!initializeAnalytics(userId)) return;

  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (name, parameters = {}) => {
  if (!initializeAnalytics()) return;
  window.gtag("event", name, parameters);
};
